import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  generalTempForm: {
    organization: "",
    parent: null,
    name: "",
    trading_name: "",
    tax_id: "",
    country: "",
    registration_number: "",
    type: "",
    salesforce_id: "",
    account_manager_name: "",
    account_manager_email: "",
  },
};

const TempFormDataSlice = createSlice({
  name: "generalTempForm",
  initialState,
  reducers: {
    setGeneralTempForm: (state, action) => {
      state.generalTempForm = { ...state.generalTempForm, ...action.payload };
    },
    resetGeneralTempForm: (state) => {
      state.generalTempForm = initialState.generalTempForm;
    },
  },
});

export const { setGeneralTempForm, resetGeneralTempForm } =
  TempFormDataSlice.actions;

export default TempFormDataSlice.reducer;
